// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR","icons":"Menu_icons__HUiOt","icon":"Menu_icon__YNNWA","active":"Menu_active__-0Z9R"};